import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoutes = () => {
  const isAuth = localStorage.getItem("isAuth");
  // const isTempAuth = localStorage.getItem("isTempAuth");
  return isAuth ? <Outlet /> : <Navigate to="/" />;
};
